import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, ShieldIcon } from 'lucide-react';
type AccordionItemProps = {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
};
function AccordionItem({
  title,
  children,
  isOpen,
  onToggle
}: AccordionItemProps) {
  return <div className="border-b border-navy/10 last:border-b-0" data-id="element-80">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-5 px-1 text-left cursor-pointer group" aria-expanded={isOpen} data-id="element-81">
        <span className="font-medium text-navy/80 group-hover:text-navy transition-colors" data-id="element-82">
          {title}
        </span>
        <motion.span animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.25
      }} className="flex-shrink-0 ml-4" data-id="element-83">
          <ChevronDownIcon className="w-5 h-5 text-navy/40" data-id="element-84" />
        </motion.span>
      </button>
      <AnimatePresence initial={false} data-id="element-85">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-86">
            <div className="pb-6 px-1 text-navy/60 text-sm leading-relaxed space-y-3" data-id="element-87">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function LegalSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-12 md:py-16 px-4 bg-cream" data-id="element-88">
      <div className="max-w-3xl mx-auto" data-id="element-89">
        <div className="flex items-center justify-center gap-2 mb-8" data-id="element-90">
          <ShieldIcon className="w-4 h-4 text-soft-blue/60" data-id="element-91" />
          <p className="text-navy/40 text-sm font-medium tracking-wide uppercase" data-id="element-92">
            Información legal
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8" data-id="element-93">
          <AccordionItem title="Política de privacidad" isOpen={openIndex === 0} onToggle={() => toggle(0)} data-id="element-94">
            <p data-id="element-95">
              En Hogar Bienestar nos comprometemos a proteger tu información
              personal. Los datos que proporciones durante el proceso de compra
              serán tratados de forma confidencial y responsable.
            </p>
            <p data-id="element-96">
              Tu información se utiliza exclusivamente para gestionar tu acceso
              al producto digital adquirido. No compartimos tus datos con
              terceros con fines comerciales.
            </p>
            <p data-id="element-97">
              El procesamiento del pago se realiza a través de Hotmart, una
              plataforma segura que cumple con los estándares de protección de
              datos vigentes. Puedes ejercer tus derechos de acceso,
              rectificación o eliminación de datos en cualquier momento
              contactándonos directamente.
            </p>
          </AccordionItem>

          <AccordionItem title="Términos y condiciones" isOpen={openIndex === 1} onToggle={() => toggle(1)} data-id="element-98">
            <p data-id="element-99">
              Noches Secas es un producto digital educativo. Al realizar tu
              compra, recibirás acceso inmediato al contenido completo del
              método en formato digital.
            </p>
            <p data-id="element-100">
              El contenido adquirido es para uso personal y familiar. Queda
              prohibida su redistribución, reventa o reproducción total o
              parcial sin autorización expresa de Hogar Bienestar.
            </p>
            <p data-id="element-101">
              Al completar la compra, aceptas que se trata de un producto
              digital de acceso inmediato. Si tienes cualquier consulta sobre tu
              compra, puedes contactarnos y te atenderemos con gusto.
            </p>
          </AccordionItem>

          <AccordionItem title="Aviso legal" isOpen={openIndex === 2} onToggle={() => toggle(2)} data-id="element-102">
            <p data-id="element-103">
              El contenido de Noches Secas es exclusivamente educativo e
              informativo. Está diseñado para ofrecer orientación y
              acompañamiento a familias, pero no constituye asesoramiento
              médico, psicológico ni profesional de ningún tipo.
            </p>
            <p data-id="element-104">
              Este método no sustituye el diagnóstico, la evaluación ni el
              tratamiento de un profesional de la salud. Si tienes dudas sobre
              la salud de tu hijo, te recomendamos consultar con su pediatra o
              especialista.
            </p>
            <p data-id="element-105">
              Cada niño tiene su propio ritmo de desarrollo. Los resultados
              pueden variar según las circunstancias individuales de cada
              familia.
            </p>
          </AccordionItem>
        </div>
      </div>
    </section>;
}